const SENTRY_RATE_LIMIT_WINDOW_MS = 60_000;
const SENTRY_MAX_EVENTS_PER_WINDOW = 10;

const recentEventTimestamps: number[] = [];

/**
 * Returns true when the client has sent too many Sentry events in the current window.
 * Prevents self-inflicted 429 rate limits during error storms (e.g. Supabase 503 floods).
 */
export function isSentryClientRateLimited(now = Date.now()): boolean {
  while (
    recentEventTimestamps.length > 0 &&
    recentEventTimestamps[0] < now - SENTRY_RATE_LIMIT_WINDOW_MS
  ) {
    recentEventTimestamps.shift();
  }
  return recentEventTimestamps.length >= SENTRY_MAX_EVENTS_PER_WINDOW;
}

/** Records that a Sentry event was sent (call from beforeSend when returning event). */
export function recordSentryClientEvent(now = Date.now()): void {
  recentEventTimestamps.push(now);
}

/** Resets rate-limit state — for unit tests only. */
export function resetSentryClientRateLimitForTests(): void {
  recentEventTimestamps.length = 0;
}
